<app-shared-card additionalClasses="mx-2 sm:mx-4 mb-3 sm:mb-4">
  <div class="grid grid-cols-3 items-center gap-4 p-4">
    <div class="flex justify-start items-center">
      <button
        (click)="previousDay()"
        [disabled]="!canNavigatePrevious"
        class="p-2 rounded-full hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center"
      >
        <lucide-icon [img]="CircleChevronLeft" class="w-5 h-5 sm:w-6 sm:h-6" />
      </button>
    </div>
    
    <div class="justify-self-center">
      <div class="flex items-center gap-2">
        <lucide-icon [img]="Calendar" class="w-5 h-5 sm:w-8 sm:h-8" />
        <div class="flex flex-col">
          <div class="text-base sm:text-xl font-semibold text-gray-900">{{ currentDayItem?.label }}</div>
          <div class="text-sm sm:text-base text-secondary-text">{{ currentDayDateFormatted }}</div>
        </div>
      </div>
    </div>
    
    <div class="flex justify-end items-center">
      <button
        (click)="nextDay()"
        [disabled]="!canNavigateNext"
        class="p-2 rounded-full hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center"
      >
        <lucide-icon [img]="CircleChevronRight" class="w-5 h-5 sm:w-6 sm:h-6" />
      </button>
    </div>
  </div>
</app-shared-card>